export const CONFIG = {
  INIT_TIMEOUT_IN_SECONDS: 10,
  FEATURE_FLAG_OVERRIDES_STORAGE_KEY: 'FEATURE_FLAG_OVERRIDES',
  FEATURE_FLAG_OVERRIDE_QUERY_PARAM_PREFIX: 'features.',
  PRIVATE_ATTRIBUTES: ['email'],
};
